import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import AdminCreateInvoiceModal from '../AdminCreateInvoiceModal/AdminCreateInvoiceModal';
import AdHocInvoiceModal from '../common/AdHocInvoiceModal/AdHocInvoiceModal';
import './CreateInvoiceDropdown.scss';

function CreateInvoiceDropdown({
  triggerText,
  csrfToken,
  projectId,
  createInvoiceUrl,
  companyName,
  projectName,
  consultantFullName,
  adHocInvoicesUrl,
}) {
  return (
    <div className="create-invoice-dropdown">
      <Dropdown
        key="create-invoice-dropdown"
        id="create-invoice-dropdown"
      >
        <Dropdown.Toggle
          className="btn-dropdown-toggle"
          variant="primary"
        >
          <span className="trigger-text">
            {triggerText}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="1">
            <AdminCreateInvoiceModal
              csrfToken={csrfToken}
              projectId={projectId}
              createInvoiceUrl={createInvoiceUrl}
              triggerText="Create Timesheet For Consultant"
              triggerType="button"
            />
          </Dropdown.Item>
          <Dropdown.Item eventKey="2">
            <AdHocInvoiceModal
              csrfToken={csrfToken}
              projectId={projectId}
              createInvoiceUrl={createInvoiceUrl}
              triggerText="Create Ad-Hoc invoice"
              triggerType="button"
              companyName={companyName}
              projectName={projectName}
              consultantFullName={consultantFullName}
              adHocInvoicesUrl={adHocInvoicesUrl}
            />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

CreateInvoiceDropdown.propTypes = {
  createInvoiceUrl: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  consultantFullName: PropTypes.string.isRequired,
  adHocInvoicesUrl: PropTypes.string.isRequired,
};

CreateInvoiceDropdown.defaultProps = {};

export default CreateInvoiceDropdown;
